import { findItemWithParents } from './findItemWithParents';
import { searchRouteInfos } from './searchRouteInfos';

export const standardizeUrlPathName = (url: string) => {
  return url.replace(/^\//, '').toLowerCase().replace(/\/$/, '');
};

export const getCurrentActiveMenuKey = (withParentKey?: boolean) => {
  const urlPathName = window.location.pathname.substring(1);

  const currentActiveMenuKey = searchRouteInfos('route', urlPathName)?.key || 'homepage';

  if (currentActiveMenuKey && withParentKey) {
    return findItemWithParents(currentActiveMenuKey);
  }

  return [currentActiveMenuKey];
};

export const isCurrentActiveMenuKey = (menuKey: string) => {
  const currentActiveMenuKey = getCurrentActiveMenuKey();

  return currentActiveMenuKey.includes(menuKey);
};
